import { useCallback } from 'react'
import { SearchItem } from '../types'

interface UseKeyboardNavigationProps {
	displayResults: SearchItem[]
	selectedIndex: number
	setSelectedIndex: (index: number) => void
	onSelect: (item: SearchItem) => void
	closeSearch: () => void
}

export const useKeyboardNavigation = ({
	displayResults,
	selectedIndex,
	setSelectedIndex,
	onSelect,
	closeSearch
}: UseKeyboardNavigationProps) => {
	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent) => {
			// If there are no results, only handle Escape
			if (!displayResults || displayResults.length === 0) {
				if (e.key === 'Escape') {
					e.preventDefault()
					closeSearch()
				}
				return
			}

			switch (e.key) {
				case 'ArrowDown':
					e.preventDefault()
					// Find next non-header item
					let nextIndex = selectedIndex + 1
					while (nextIndex < displayResults.length && (displayResults[nextIndex] as any)?.isGroupHeader) {
						nextIndex++
					}

					if (nextIndex < displayResults.length) {
						setSelectedIndex(nextIndex)
					}
					break
				case 'ArrowUp':
					e.preventDefault()
					// Find previous non-header item
					let prevIndex = selectedIndex - 1
					while (prevIndex >= 0 && (displayResults[prevIndex] as any)?.isGroupHeader) {
						prevIndex--
					}

					if (prevIndex >= 0) {
						setSelectedIndex(prevIndex)
					}
					break
				case 'Enter':
					e.preventDefault()
					if (displayResults[selectedIndex] && !(displayResults[selectedIndex] as any)?.isGroupHeader) {
						onSelect(displayResults[selectedIndex])
					}
					break
				case 'Escape':
					e.preventDefault()
					closeSearch()
					break
				default:
					break
			}
		},
		[displayResults, selectedIndex, setSelectedIndex, onSelect, closeSearch]
	)

	return handleKeyDown
}
